import request from "../utils/request";
import { IUser, ITopup, IOrders } from "@/interface";

/**
 * @description: 请求语言列表
 */

export const getLanguageList = () => {
  return request({
    url: "/api/yotopup/LanguageList",
    method: "get"
  });
};

/**
 * @description: 获取网站资源
 * @param {string} lang 语言key
 * @return: { "siteAssets", "gameList" }
 */

export const getSiteAssets = (lang: string) => {
  return request({
    url: "/api/yotopup/SiteAssets",
    method: "get",
    params: { lang }
  });
};

/**
 * @description: 获取游戏页面资源
 * @param {string} lang 语言key
 * @param {string} gameId 游戏id
 */

export const getGameAssets = (lang: string, gameId: string) => {
  return request({
    url: "/api/yotopup/GameAssets",
    method: "get",
    params: { lang, gameId }
  });
};

/**
 * @description: 获取服务器列表
 * @param {string} gameId 游戏id
 * @return: [{ "serverId": "string", "serverName": "string" }]
 */

export const getServerList = (gameId: string) => {
  return request({
    url: "/api/yotopup/ServerList",
    method: "get",
    params: { gameId }
  });
};

/**
 * @description: 验证用户
 * @param {User} user 用户信息
 * @return: { "userName": "string" } 用户名
 */

export const ValidateUser = (user: IUser) => {
  return request({
    url: "/api/yotopup/ValidateUser",
    method: "post",
    data: user
  });
};

async function execRecaptcha () {
  return new Promise<string>((resolve, reject) => {
    const grecaptcha = (window as any).grecaptcha; // eslint-disable-line

    if (!grecaptcha) {
      throw new Error("reCAPTCHA is undefined");
    }

    grecaptcha.ready(() => {
      grecaptcha.execute(process.env.VUE_APP_RECAPTCHA_KEY, { action: "topup" })
        .then((token: string) => resolve(token))
        .catch((error: Error) => reject(error));
    });
  });
}

/**
 * @description: 充值
 * @param {ITopup} topup 充值信息
 * @return: { "redirectUrl": "string" } 回调url
 */

export const TopUp = async (topup: ITopup) => {
  // const timer = Date.now();

  const token = await execRecaptcha();

  // console.log("token:", token, Date.now() - timer);

  return request({
    url: "/api/yotopup/TopUp",
    method: "post",
    headers: {
      "X-RECAPTCHA-TOKEN": token
    },
    data: topup
  });
};

/**
 * @description: 查询订单信息
 * @param {IOrders} orderInquiry
 */
export const InquiryItem = (orderInquiry: IOrders) => {
  return request({
    url: "/api/yotopup/Inquiry",
    method: "post",
    data: orderInquiry
  });
};
